<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    emptyText: {
      type: String,
      default: '',
    },
    options: {
      type: [Object, Array],
      required: true,
    },
    optionText: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      required: true,
    },
    error: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    disabled: {
      type: Boolean,
    },
    changed: {
      type: Boolean,
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },
}
</script>

<template>
  <div class="position-relative">
    <Multiselect
      v-model="model"
      :class="['motto-multi-select', changed ? 'motto-multi-select-changed' : '']"
      :disabled="disabled"
      :placeholder="placeholder"
      :options="options"
      :multiple="true"
      :label="optionText ? optionText : null"
      :track-by="optionText ? optionText : null"
      :searchable="false"
      :show-labels="false"
      :block-keys="['Tab', 'Enter']"
      @input="
        (changedValue) => {
          $emit('input', changedValue)
        }
      ">
      <template v-slot:tag="{ option, remove }"><slot name="tag" :option="option" :remove="remove"></slot></template>
    </Multiselect>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.select {
  width: 100%;
  height: 40px;
  padding: 8px 45px 10px 16px;
  font-size: 16px;
  color: $dark-gray;
  cursor: pointer;
  background-color: $white;
  border: 0.5px $primary-blue solid;
  border-radius: 36px;
  outline: none;
  appearance: none;
}

.errorContainer {
  position: absolute;
  right: 0;
  left: 0;

  .errorMessage {
    @extend %error-message;

    text-align: center;
  }
}

.selectDownArrow {
  position: absolute;
  top: 12px;
  right: 18px;
  color: $gray;
  pointer-events: none;
}
</style>
